import { isValidElement, ReactElement, ChangeEventHandler } from 'react';

interface CheckboxRadioProps {
    /** флаг состояния по умолчанию - включен - true, выключен/отсутствует - false */
    checked?: boolean;
    /** компонент отключен для взаимодействия */
    disabled?: boolean;
    /** ошибка валидации */
    invalid?: boolean;
    /** функция действия на изменение состояния */
    onChange?: ChangeEventHandler<HTMLInputElement>;
    /** атрибут aria-label */
    'aria-label'?: string;
    /** атрибут data-qa для контейнера */
    dataQaContainer?: string;
    /** атрибут data-qa для инпута */
    'data-qa'?: string;
}

export interface RadioBaseProps extends CheckboxRadioProps {
    /** атрибут data-qa для визуального элемента выполняющего роль радио */
    dataQaRadio?: string;
}

export type RadioProps = RadioBaseProps & JSX.IntrinsicElements['input'];

export type CheckboxProps = CheckboxRadioProps & {
    /** визуальное состояние неопределено */
    indeterminate?: boolean;
    /** атрибут data-qa для визуального элемента выполняющего роль чекбокса */
    dataQaCheckbox?: string;
} & JSX.IntrinsicElements['input'];

export const isCheckboxComponent = (component: ReactElement): component is ReactElement<CheckboxProps> => {
    return isValidElement(component) && typeof component.type !== 'string' && 'isCheckbox' in component.type;
};

export const isRadioComponent = (component: ReactElement): component is ReactElement<RadioProps> => {
    return isValidElement(component) && typeof component.type !== 'string' && 'isRadio' in component.type;
};
